import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableContainer,
  Typography,
  TableRow,
  TableCell,
  Button,
  useMediaQuery,
  Tooltip,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import NoDataFoundIcon from "../assets/icon_noresults.png";
import ContentLoadingScreen from "./ContentLoadingScreen";

import useTable, { emptyRows } from "../hooks/useTable";
import TimesheetContext from "../contexts/TimesheetContext";
import {
  TableEmptyRows,
  TableHeadCustom,
  TableRowWithDelete
} from "../components/table";

import SearchTableToolbar from "../sections/clients/SearchTableToolbar";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import useAxiosPrivate, { isValidResponse } from "../hooks/useAxiosPrivate";
import { displayError } from "../utils/handleErrors";
import useLocales from "../hooks/useLocales";

import Pagination from "@mui/material/Pagination";

import { createStyles } from "@mui/styles";
import { useTheme } from "@emotion/react";

import NoDataFound from "../components/NoDataFound";
import DeletePopUp from "./DeletePopUp";
import { anchorOrigin } from "../utils/constants";
import RegenrateFormDialog from "../sections/Invoicing/GenerateInvoice";
import useClient from "../hooks/useClient";
import PDFDialog from "../sections/Invoicing/SendEmailDialog";
import { debounce } from "lodash";
import AddFormModal from "./AddFormModal";
import EmpAddTimesheet from "../sections/TimeSheet/EmpAddTimesheet";
import ResponsivePagination from "../theme/ResponsivePagination";
import { DeleteAllocationModal } from "../sections/Allocations/DeleteAllocationModal";
import { DeleteEmployeeModal } from "../sections/SettingManagment/EmployeeModule/DeleteEmployeeModal";
import { useSelectedTab } from "../contexts/SelectedTabContext";
ListingPage.propTypes = {
  timesheetPage: PropTypes.bool,
  invoicePage: PropTypes.bool,

  searchQuery: PropTypes.string,

  onSearchQueryChange: PropTypes.func
};
export default function ListingPage({
  allowDelete,
  searchByPlaceholder,
  sortOrder,
  handleSortChange,
  hideInactiveDelete,
  displaySorting = false,
  hideSearch,
  consultantsList,
  isProxyTimesheet,
  proxyEmpEmail,
  proxyEmpId,
  changeSelectedTab,
  isClientList,
  column = [],
  noDataMsgId,
  filterView,
  filterItems,
  fetchListAPI,
  deleteItemAPI,
  handleRowClick,
  handleRowEdit,
  searchQuery,
  onSearchQueryChange,
  refreshCount = 0,
  timesheetPage,
  invoicePage,
  markAsPaidAPI,
  sendEmailAPI,
  screen,
  searchType,
  clientId,
  setRefreshCount,
  employeeId,
  clinetNameArr,
  weekWiseTimesheetPage,
  MissingTimesheetsPage,
  ListingPage,
  isManagerView,
  showApproveModal,
  isDeletePlacement,
  isDeleteEmployee,
  isActivityLogsPage,
  isEmployeeOverview
  ,
  // Asset listing specific search enhancements
  assetSearchMode = false,
  assetSearchKeys = [], // [{ value: 'asset_name', label: 'Asset Name' }, ...]
  defaultAssetSearchKey = 'asset_name'
}) {
  useEffect(() => {
    console.log("******hideInactiveDelete", hideInactiveDelete);
  }, [hideInactiveDelete]);
  const { page, order, orderBy, rowsPerPage, scrollToTop } = useTable();
  const pageSizeAPI = 100;
  const handleSnackbar = (messageKey, variant = "success") => {
    enqueueSnackbar(translate(messageKey), { anchorOrigin, variant });
  };
  const theme = useTheme();
  const styles = useStyles(theme);

  const axiosPrivate = useAxiosPrivate();
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();
  const [isAddModel, setAddModel] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [cirleLoder, setCirleLoder] = React.useState(false);
  const [isNoData, setNoData] = React.useState(false);

  const [isSearching, setSearching] = React.useState(false);

  const isControlled =
    typeof searchQuery === "string" &&
    typeof onSearchQueryChange === "function";
  const [uncontrolledSearchTerm, setUncontrolledSearchTerm] = useState("");
  const searchTerm = isControlled ? searchQuery : uncontrolledSearchTerm;

  const [apiPageDataMap, setAPIPageDataMap] = useState({});

  const [masterDataList, setMasterDataList] = useState([]);

  const [totalAPIResultCount, setTotalAPIResultCount] = useState(0);

  const [apiPageNumber, setAPIPageNumber] = useState(1);
  const [uiPageNumber, setUiPageNumber] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const [totalFilterRecords, setTotalFilterRecords] = useState(0);

  const [filteredRows, setFilteredRows] = useState([]);
  // Asset search key state (only used when assetSearchMode is true)
  const [selectedSearchKey, setSelectedSearchKey] = useState(defaultAssetSearchKey);
  useEffect(() => {
    setSelectedSearchKey(defaultAssetSearchKey);
  }, [defaultAssetSearchKey]);
  const { selectedClient } = useClient();
  const [alocatedDataHrs, setAllocatedDataHrs] = useState([]);
  const [isRecall, setIsRecall] = useState(false);
  const onCloseAddModel = () => {
    setAddModel(false);
    fetchList();
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  const fetchList = async () => {
    if (!isManagerView) {
      setLoading(true); // Set loading state to true before starting the fetch
      try {
        const resp = await fetchListAPI(axiosPrivate, 1, pageSizeAPI);
        if (isValidResponse(resp)) {
          setTotalAPIResultCount(resp.data.count);
          setMasterDataList(resp.data.results);
          const renderChunk = resp.data.results.slice(0, 10);
          setFilteredRows(renderChunk);
        } else {
          onError(translate("error.fetch"));
        }
      } catch (error) {
        onError(translate("error.fetch"));
      } finally {
        setLoading(false); // Set loading state to false after the fetch is complete
      }
    } else {
      setCirleLoder(true);
      try {
        const resp = await fetchListAPI(axiosPrivate, 1, pageSizeAPI);
        if (isValidResponse(resp)) {
          setTotalAPIResultCount(resp.data.count);
          setMasterDataList(resp.data.results);
          const renderChunk = resp.data.results.slice(0, 10);
          setFilteredRows(renderChunk);
        } else {
          onError(translate("error.fetch"));
        }
      } catch (error) {
        onError(translate("error.fetch"));
      } finally {
        setCirleLoder(false);
      }
    }
  };
  useEffect(() => {
    fetchList();
  }, [refreshCount]);

  const onPageChange = async (event, page) => {
    const toBeApiPageNum = Math.ceil(page / 10);

    if (toBeApiPageNum != apiPageNumber) {
      setLoading(true);
      const resp = await fetchListAPI(
        axiosPrivate,
        toBeApiPageNum,
        pageSizeAPI
      );
      setLoading(false);
      setTotalAPIResultCount(resp.data.count);
      setMasterDataList(resp.data.results);
      setAPIPageNumber(toBeApiPageNum);
      setUiPageNumber(page);
      scrollToTop();
      const SI = ((page - 1) % 10) * 10;
      const EI = SI + 10;

      const renderChunk = resp.data.results.slice(SI, EI);
      setFilteredRows(renderChunk);
    } else {
      setUiPageNumber(page);
      scrollToTop();
      const SI = ((page - 1) % 10) * 10;
      const EI = SI + 10;
      const dataToPaginate = searchTerm
        ? masterDataList.filter((row) =>
            row.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : masterDataList;

      const renderChunk = dataToPaginate.slice(SI, EI);
      setFilteredRows(renderChunk);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(totalFilterRecords / rowsPerPage));
  }, [totalFilterRecords]);

  useEffect(() => {
    setNoData(totalAPIResultCount === 0);
  }, [totalAPIResultCount]);

  useEffect(() => {
    updateFilterData();
  }, [searchTerm, masterDataList, filterItems]);
  const { setSelectedNavigationTab } = useSelectedTab();
  const handleDeleteRow = (deletedRow) => {
    onRowDeleted(deletedRow);
  };

  const debouncedSearch = React.useCallback(
    // Debounce search by 2 seconds. Loader will only show AFTER the 2s wait when the debounced
    // function actually runs, avoiding flicker while the user is typing.
    debounce(async (searchValue, searchType, clientId) => {
      // Mark searching at the very beginning of a debounced search
      setSearching(true);
      // If the search input is cleared, show the full list
      if (!searchValue) {
        // For all search types, when search is cleared, fetch the full list again
        try {
          const response = await fetchListAPI(axiosPrivate, 1, pageSizeAPI);
          if (isValidResponse(response)) {
            setTotalAPIResultCount(response.data.count);
            setMasterDataList(response.data.results);
            const renderChunk = response.data.results.slice(0, rowsPerPage);
            setFilteredRows(renderChunk);
            setTotalFilterRecords(response.data.count);
            setUiPageNumber(1);
          }
        } catch (error) {
          onError(translate("error.fetch"));
        } finally {
          // Ensure loader stops when clearing the search
          setSearching(false);
        }
        return;
      }

      // Prepare params for the API call
      const params = {
        search_query: searchValue,
        search_type: searchType
      };

      if (
        searchType !== "client" &&
        searchType !== "skill_payrate" &&
        !clientId
      ) {
        console.error("client_id is required for this search type");
      } else if (clientId && searchType !== "skill_payrate") {
        params.client_id = clientId;
      }
      // Perform the search via API
      try {
        let response;
        if (assetSearchMode) {
          // Use the dedicated asset search endpoint with search_key
          const baseType = searchType?.includes('hardware')
            ? 'hardware'
            : (searchType?.includes('software') ? 'software' : searchType);
          const effectiveType = (selectedSearchKey === 'asset_name')
            ? searchType
            : (baseType === 'hardware' ? 'hardware' : (baseType === 'software' ? 'software_asset' : baseType));
          const assetParams = {
            search_type: effectiveType,
            search_key: selectedSearchKey || defaultAssetSearchKey,
            search_query: searchValue
          };
          response = await axiosPrivate.get(`/asset-auto-search/`, { params: assetParams });
          const filteredList = response.data?.results ?? response.data ?? [];
          setFilteredRows((Array.isArray(filteredList) ? filteredList : []).slice(0, rowsPerPage));
          setTotalFilterRecords(Array.isArray(filteredList) ? filteredList.length : 0);
        } else {
          response = await axiosPrivate.get(`/auto-search/`, { params });
          const filteredList = response.data.results;
          setFilteredRows(filteredList.slice(0, rowsPerPage)); // Update rows with API response
          setTotalFilterRecords(filteredList.length); // Update count
        }
        setUiPageNumber(1); // Reset pagination
      } catch (error) {
        enqueueSnackbar(
          "An error occurred during the search. Please try again.",
          { variant: "error", anchorOrigin }
        );
      } finally {
        // Always stop showing the search loader after API completes
        setSearching(false);
      }
    }, 2000), // 2000ms (2s) debounce delay per requirement
    [axiosPrivate, masterDataList, rowsPerPage, clientId, fetchListAPI, assetSearchMode, selectedSearchKey, defaultAssetSearchKey]
  );

  // Handle input changes and trigger debounce
  const handleSearch = (searchValue) => {
    if (isControlled) {
      onSearchQueryChange(searchValue);
    } else {
      setUncontrolledSearchTerm(searchValue); // Update the search term state
    }
    // Ensure the loader does NOT show immediately in asset search mode.
    // We only show it inside the debounced function after 2 seconds.
    if (assetSearchMode) {
      setSearching(false);
    }
    debouncedSearch(searchValue, searchType, clientId); // Call the debounced function
  };

  const onError = (message) => {
    enqueueSnackbar("Listing - " + message, {
      anchorOrigin,
      variant: "error"
    });
  };

  async function onRowDeleted(deletedRow) {
    let updatedAPIPageDataMap = [];
    Object.keys(apiPageDataMap).forEach((key) => {
      const rows = apiPageDataMap[key];
      const updatedRows = rows.filter((row) => row.uuid !== deletedRow.uuid);
      updatedAPIPageDataMap = [...updatedAPIPageDataMap, ([key] = updatedRows)];
    });
    setAPIPageDataMap(updatedAPIPageDataMap);
    updateMasterListData(updatedAPIPageDataMap);
    setTotalAPIResultCount((current) => current - 1);

    setFilteredRows(filteredRows.filter((row) => row.uuid !== deletedRow.uuid));
    setTotalFilterRecords((current) => current - 1);
  }

  async function updateFilterData() {
    const isFilterEnabled = hasFilterValues();

    // In asset search mode we do NOT perform local filtering while the user is typing.
    // The debounced API search (debouncedSearch) will update rows and control the loader.
    if (assetSearchMode && searchTerm && !isFilterEnabled) {
      return; // avoid toggling the searching loader immediately on keypress
    }

    if (!searchTerm && !isFilterEnabled) {
      applyTableData(masterDataList, totalAPIResultCount);
      return;
    }

    // Show local filtering loader only when not in asset search mode, or when filters are applied
    if (!assetSearchMode || isFilterEnabled) {
      setSearching(true);
    }

    let list = [];

    for (const dataItem of masterDataList) {
      let rowString = "";
      let hasSelectedByFilter = isFilterEnabled;
      let filterItemCount = 0;
      let filterMatchedCount = 0;
      for (const colItem of column) {
        const cellFormatValue =
          typeof colItem?.format === "function"
            ? colItem.format(dataItem)
            : dataItem[colItem.key] ?? "";

        if (searchTerm) {
          rowString += cellFormatValue + "";
        }

        if (hasSelectedByFilter) {
          const filterValue = filterItems[colItem.id];
          if (filterValue && filterValue.length > 0) {
            filterItemCount += 1;
            if (filterValue.toLowerCase() === cellFormatValue?.toLowerCase()) {
              filterMatchedCount += 1;
            }
          }
        }
      }

      if (hasSelectedByFilter) {
        hasSelectedByFilter = filterItemCount === filterMatchedCount;
      }

      let canAddToResult = false;
      if (searchTerm) {
        if (
          (!isFilterEnabled || hasSelectedByFilter) &&
          rowString.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          canAddToResult = true;
        }
      } else if (hasSelectedByFilter) {
        canAddToResult = true;
      }

      if (canAddToResult) {
        list = [...list, dataItem];
      }
    }

    applyTableData(list, list.length);
    if (!assetSearchMode || isFilterEnabled) {
      setSearching(false);
    }
  }

  async function fetchListFromAPI(apiPage) {
    if (isLoading) return;

    setLoading(true);
    if (fetchListAPI) {
      try {
        const response = await fetchListAPI(axiosPrivate, apiPage, pageSizeAPI);

        if (isValidResponse(response)) {
          setTotalAPIResultCount(response.data.count);
          const newDataList = response.data.results
            ? response.data.results
            : response.data;
          const updatePageDataMap = apiPageDataMap;
          updatePageDataMap[apiPage] = newDataList;
          setAPIPageDataMap(updatePageDataMap);
          updateMasterListData(updatePageDataMap);
          // onError(translate("error.fetch"));
        } else {
          onError(translate("error.fetch"));
        }
      } catch (error) {
        console.log("Error in fetchListFromAPI ", error);
        onError(translate("error.fetch"));
      }
    }

    setLoading(false);
  }

  function updateMasterListData(updatePageDataMap) {
    let list = [];
    Object.keys(updatePageDataMap).forEach((key) => {
      const rows = updatePageDataMap[key];
      if (rows?.length > 0) {
        list = [...list, ...rows];
      }
    });
  }

  function applyTableData(tableDataToSet, tableDataCount, currentPage) {
    setTotalFilterRecords(tableDataCount);
  }

  function getTotalPaginationLabel() {
    return `Showing
    ${Math.min(totalFilterRecords, (uiPageNumber - 1) * rowsPerPage + 1)} to
    ${Math.min(
      totalFilterRecords,
      uiPageNumber * rowsPerPage
    )} of ${totalFilterRecords}
    results`;
  }

  function hasFilterValues() {
    let hasValue = false;

    if (filterItems) {
      Object.keys(filterItems).forEach((key) => {
        if (filterItems[key]?.length > 0) {
          hasValue = true;
        }
      });
    }

    return hasValue;
  }

  const ListingTableRow = ({
    row,
    columns,
    onEditRow,
    onItemClick,
    onDeleteRow,
    handleRowClick
  }) => {
    // Add row click handler if provided via props
    const handleClick = () => {
      if (typeof handleRowClick === "function") {
        handleRowClick(row);
      } else if (typeof onItemClick === "function") {
        onItemClick(row);
      }
    };
    const [isDeletePopUp, setDeletePopUp] = React.useState(false);
    const [isRegeneratePopUp, setRegeneratePopUp] = React.useState(false);
    const [isSendEmailPopUp, setIsSendEmailPopUp] = React.useState(false);

    const onOpenDeletePopup = () => {
      setDeletePopUp(true);
    };

    const onCloseDeletePopup = () => {
      setDeletePopUp(false);
    };

    const handleDelete = () => {
      console.log("del row", row);
      deleteItemRow();
    };

    //Renerate
    const onOpenRegeneratePopUp = () => {
      setRegeneratePopUp(true);
    };

    const onCloseRegeneratePopUp = () => {
      setRegeneratePopUp(false);
    };

    //Email
    const onOpenEmailPopUp = () => {
      setIsSendEmailPopUp(true);
    };

    const onCloseSendEmailPopUp = () => {
      setIsSendEmailPopUp(false);
    };

    const handleSendEmailClick = (newData) => {
      const formData = new FormData();
      if (newData.files) {
        formData.append("files", newData.files, "invoice.pdf"); // You can specify the file name
      }
      formData.append("client_id", selectedClient.uuid);
      formData.append("invoice_id", row.c2c_invoice_id);
      Object.keys(newData).forEach((key) => {
        if (key !== "files") {
          formData.append(key, newData[key]);
        }
      });
      SendItemEmail(formData);
    };

    //PAid
    const onHandlePaidClick = (payloadData) => {
      if (payloadData.c2c_invoice_status === "Active") {
        const payload = {
          client_id: selectedClient.uuid,
          invoice_id: payloadData.c2c_invoice_id,
          invoice_status: "Paid"
        };
        markAsPaidInvoiceItemRow(payload);
      } else {
        enqueueSnackbar(translate("message.alreadyPaid"), { anchorOrigin });
      }
    };

    //timesheetsubmit
    const onSubmitTimsheetClick = (row, isRecalled = false) => {
      if (isRecalled) {
        setIsRecall(true);
      }
      if (MissingTimesheetsPage) {
        setAllocatedDataHrs([
          {
            client_name: row.client_name,
            contract_sow_name: row.contract_sow_name,
            allocated_hours: row.allocated_hours,
            week_number: row.week_number,
            start_date: row.week_start_date,
            end_date: row.week_end_date
          }
        ]);
      } else
        setAllocatedDataHrs([
          {
            client_name: row.client_name,
            contract_sow_name: row.contract_sow_name,
            allocated_hours: row.allocated_hours,
            week_number: row.week_number,
            start_date: row.start_date,
            end_date: row.end_date
          }
        ]);
      openAddTimesheetModel();
    };

    const openAddTimesheetModel = () => {
      setAddModel(true);
    };

    //Mark as paid
    async function markAsPaidInvoiceItemRow(payload) {
      if (markAsPaidAPI) {
        try {
          const response = await markAsPaidAPI(axiosPrivate, payload);
          if (isValidResponse(response)) {
            enqueueSnackbar(translate("message.markAsPaid"), { anchorOrigin });
            fetchListFromAPI(apiPageNumber);
            fetchList();
          } else {
            displayError(enqueueSnackbar, {
              message: translate("error.MarkAsPaidFailed"),
              anchorOrigin
            });
          }
        } catch (error) {
          displayError(enqueueSnackbar, error, {
            anchorOrigin
          });
        }
      }
    }

    //Send mail
    async function SendItemEmail(payload) {
      if (sendEmailAPI) {
        try {
          const response = await sendEmailAPI(axiosPrivate, payload);
          if (isValidResponse(response)) {
            onCloseSendEmailPopUp();
            enqueueSnackbar(translate("message.emailSent"), { anchorOrigin });
            fetchListFromAPI(apiPageNumber);
            fetchList();
          } else {
            displayError(enqueueSnackbar, {
              message: translate("error.sendEmailFailed"),
              anchorOrigin
            });
          }
        } catch (error) {
          displayError(enqueueSnackbar, error, {
            anchorOrigin
          });
          onCloseSendEmailPopUp();
        }
      }
    }

    async function deleteItemRow() {
      if (deleteItemAPI) {
        try {
          const response = await deleteItemAPI(
            axiosPrivate,
            row.uuid ?? row.id ?? row?.guest_user_id ?? row.employee_id
          );
          if (isValidResponse(response)) {
            onDeleteRow(row);
            onCloseDeletePopup();

            enqueueSnackbar(translate("message.delete"), { anchorOrigin });
            setRefreshCount((current) => current + 1);
          } else {
            displayError(enqueueSnackbar, {
              message: translate("error.deleteFail"),
              anchorOrigin
            });
          }
        } catch (error) {
          displayError(enqueueSnackbar, error, {
            anchorOrigin
          });
        }
      }
    }

    return (
      <>
        <TableRowWithDelete
          row={row}
          columns={columns}
          onEditRow={onEditRow}
          onDeleteRow={onOpenDeletePopup}
          onItemClick={onItemClick}
          timesheetPage={timesheetPage}
          invoicePage={invoicePage}
          weekWiseTimesheetPage={weekWiseTimesheetPage}
          MissingTimesheetsPage={MissingTimesheetsPage}
          onRegenerateClick={onOpenRegeneratePopUp}
          onEmailClick={onOpenEmailPopUp}
          onSubmitTimsheetClick={onSubmitTimsheetClick}
          onPaidClick={onHandlePaidClick}
          screen={screen}
          allowDelete={allowDelete}
          isActivityLogsPage={isActivityLogsPage}
          isEmployeeOverview={isEmployeeOverview}
          showDelete={hideInactiveDelete}
        />

        {isDeletePopUp && (
          <>
            {isDeletePlacement ? (
              <DeleteAllocationModal
                onClose={onCloseDeletePopup}
                onDelete={handleDelete}
                allocationId={row.uuid}
                allocationList={masterDataList}
                setRefreshCount={setRefreshCount}
                row={row}
              />
            ) : isDeleteEmployee ? (
              <Box>
                <DeleteEmployeeModal
                  onClose={onCloseDeletePopup}
                  employeeId={row.employee_id}
                  employeeList={masterDataList}
                  setRefreshCount={setRefreshCount}
                  row={row}
                />
              </Box>
            ) : (
              <DeletePopUp
                onClose={onCloseDeletePopup}
                onDelete={handleDelete}
              />
            )}
          </>
        )}
        {isRegeneratePopUp && (
          <RegenrateFormDialog
            onClose={onCloseRegeneratePopUp}
            row={row}
            onRefreshData={() => {
              fetchListFromAPI(apiPageNumber);
              fetchList();
            }}
          />
        )}
        {isSendEmailPopUp && (
          <PDFDialog
            onClose={onCloseSendEmailPopUp}
            handleSendEmailClick={handleSendEmailClick}
            row={row}
          />
        )}
      </>
    );
  };

  const SearchFilterHeader = () => {
    return (
      <Box sx={styles.searchBarContainer}>
        <Box sx={styles.searchInput}>
          <SearchTableToolbar
            searchByPlaceholder={searchByPlaceholder}
            searching={isSearching}
            searchQuery={searchTerm}
            onSearch={handleSearch}
          />
        </Box>
        {assetSearchMode && (
          <Box sx={{ minWidth: 220, ml: 2 }}>
            <FormControl fullWidth size="small">
              <InputLabel id="search-key-label">Search by</InputLabel>
              <Select
                labelId="search-key-label"
                id="search-key-select"
                value={selectedSearchKey}
                label="Search by"
                onChange={async (e) => {
                  const newKey = e.target.value;
                  setSelectedSearchKey(newKey);
                  // Clear the search query and input when Search by changes
                  if (isControlled) {
                    onSearchQueryChange("");
                  } else {
                    setUncontrolledSearchTerm("");
                  }
                  // Cancel any pending debounced search and reset loader
                  if (debouncedSearch?.cancel) {
                    debouncedSearch.cancel();
                  }
                  setSearching(false);
                  // Immediately reload full list
                  await fetchList();
                  setUiPageNumber(1);
                }}
              >
                {(assetSearchKeys || []).map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        {displaySorting && (
          <Box sx={{ minWidth: 200, ml: 2 }}>
            <FormControl fullWidth size="small">
              <InputLabel id="sort-contracts-label">Sort by</InputLabel>
              <Select
                labelId="sort-contracts-label"
                id="sort-contracts"
                value={sortOrder}
                label="Sort by"
                onChange={handleSortChange}
              >
                <MenuItem value="">Default</MenuItem>
                <MenuItem value="start_date">Start Date (A-Z)</MenuItem>
                <MenuItem value="-start_date">Start Date (Z-A)</MenuItem>
                <MenuItem value="end_date">End Date (A-Z)</MenuItem>
                <MenuItem value="-end_date">End Date (Z-A)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
        {filterView}
      </Box>
    );
  };

  const ListingTable = () => {
    return (
      <Box>
        <Card sx={{ padding: "12px", marginTop: "15px" }}>
          <TableContainer>
            <Table>
              <TableHeadCustom
                order={order}
                orderBy={orderBy}
                headLabel={column}
                rowCount={filteredRows?.length}
                sx={styles.TableHeadCustom}
              />

              <TableBody sx={{ cursor: "pointer" }}>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row, index) => (
                    <ListingTableRow
                      key={row.uuid + "_" + index}
                      columns={column}
                      row={row}
                      onDeleteRow={handleDeleteRow}
                      onEditRow={() => handleRowEdit(row)}
                      onItemClick={() => {
                        handleRowClick(row);
                        if (changeSelectedTab) {
                          if (isClientList) {
                            localStorage.setItem("selectedTab", "client");
                            setSelectedNavigationTab("client");
                          } else {
                            localStorage.setItem("selectedTab", "budget");
                            setSelectedNavigationTab("budget");
                          }
                        }
                      }}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={column.length} align="center">
                      <div style={styles.noDataContainer}>
                        <img
                          src={NoDataFoundIcon}
                          alt="No Data Found"
                          style={styles.noDataImage}
                        />
                        <div style={styles.noDataMessage}>
                          {MissingTimesheetsPage
                            ? "No data found"
                            : "No data found for your search query"}
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                )}

                <TableEmptyRows
                  height={60}
                  emptyRows={emptyRows(page, rowsPerPage, filteredRows.length)}
                />
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={styles.bottomPaginationLabel}>
            <Typography variant="body2">{getTotalPaginationLabel()}</Typography>
            <ResponsivePagination
              variant="outlined"
              shape="rounded"
              page={uiPageNumber}
              count={totalPages}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 2}
              size={isMobile ? "small" : "medium"}
              onChange={onPageChange}
            />
          </Box>
        </Card>
      </Box>
    );
  };

  return (
    <>
      {isManagerView && cirleLoder ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          mt="50px"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      ) : isLoading ? (
        <ContentLoadingScreen />
      ) : (
        <>
          {isNoData ? (
            <NoDataFound msgId={noDataMsgId} />
          ) : (
            <>
              {!(
                weekWiseTimesheetPage ||
                MissingTimesheetsPage ||
                consultantsList ||
                hideSearch ||
                isActivityLogsPage
              ) && <SearchFilterHeader />}
              <ListingTable />
              {isAddModel && (
                <AddFormModal onClose={onCloseAddModel}>
                  <EmpAddTimesheet
                    isProxyTimesheet={isProxyTimesheet}
                    proxyEmpEmail={proxyEmpEmail}
                    proxyEmpId={proxyEmpId}
                    alocatedDataHrs={alocatedDataHrs}
                    ongoingProjectArr={alocatedDataHrs}
                    employeeId={employeeId}
                    handleClose={onCloseAddModel}
                    clinetNameArr={clinetNameArr}
                    weekWiseTimesheetPage={weekWiseTimesheetPage}
                    isRecall={isRecall}
                    setIsRecall={setIsRecall}
                  />
                </AddFormModal>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

const useStyles = createStyles((theme) => ({
  clientInput: {
    width: 170,
    backgroundColor: theme.palette.primary.contrastText,
    border: theme.palette.primary.contrastText,
    borderRadius: "12px"
  },
  searchInput: {
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: "12px",
    width: "40%"
  },
  TableHeadCustom: {
    margin: 0,
    width: 100,
    "&:hover": {
      backgroundColor: theme.palette.primary.contrastText
    }
  },
  searchBarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 2
  },
  bottomPaginationLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px 0",
    marginTop: "90px"
  },
  noDataImage: {
    width: "100px",
    marginBottom: "10px",

    filter: "brightness(0) saturate(1000%) hue-rotate(0deg)"
  },
  noDataMessage: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "red"
  }
}));
